import { render, staticRenderFns } from "./GoodsItem.vue?vue&type=template&id=7b0dc9b8&scoped=true"
import script from "./GoodsItem.vue?vue&type=script&lang=js"
export * from "./GoodsItem.vue?vue&type=script&lang=js"
import style0 from "./GoodsItem.vue?vue&type=style&index=0&id=7b0dc9b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0dc9b8",
  null
  
)

export default component.exports